import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {
  ClasificacionEquipo,
  GenerarOtraRondaEquiposRequestDTO,
  PairingDTO,
} from "@/interfaces/Torneo";
import { ref, watch, computed } from "vue";

import {
  EquipoDTO,
  TorneoEquipoGestionInfoDTO,
} from "@/interfaces/Inscripcion";
import ModalError from "@/components/Commons/ModalError.vue";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import { generarOtraRondaTorneoEquipos } from "@/services/TorneosService";
import { PartidaTorneoDTO } from "@/interfaces/Partidas";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalParametrosRondasEquipo',
  props: {
    isVisible: { type: Boolean },
    torneo: {},
    clasificacion: {},
    ronda: {},
    partidas: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const esParejas = computed(() => props.torneo?.torneo.tipoTorneo === "Parejas");

const emit = __emit;

const internalIsVisible = ref(props.isVisible);

// Por defecto sin repetir rival, lo normal en un suizo; si no hay forma de emparejar sin repetir, la ventana lo avisa
const esRepetirRivalCheck = ref<string>("NO");
const opcionImpares = ref<string>("NO");
const isImpares = ref<boolean>(false);
const numeroRonda = ref<number>();
const isGenerating = ref<boolean>(false);
const errorRonda = ref<string | null>(null);
const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const clasififacionEquipo = ref<EquipoDTO[]>();

watch(
  () => props.torneo?.equipos,
  (equipos) => {
    if (equipos && equipos.length > 0) {
      isImpares.value = equipos.length % 2 !== 0;
    } else {
      isImpares.value = false;
    }
  },
  { immediate: true }
);

watch(
  () => props.isVisible,
  (newValue) => {
    internalIsVisible.value = newValue;
  }
);

const closeModal = () => {
  internalIsVisible.value = false;
  emit("close");
};

const confirmGenerate = () => {
  internalIsVisible.value = false;
  emit("confirm");
};

watch(numeroRonda, (newValue) => {
  if (newValue) {
    errorRonda.value = null;
  }
});

const equiposOrdenados = computed(() => {
  if (!props.torneo?.equipos || !props.clasificacion) return [];

  const mapEquipos = new Map<number, EquipoDTO>();
  props.torneo.equipos.forEach((equipo) => {
    mapEquipos.set(equipo.idEquipo, equipo);
  });

  return props.clasificacion
    .map((clasificado) => mapEquipos.get(clasificado.idEquipo))
    .filter((equipo): equipo is EquipoDTO => equipo !== undefined);
});

watch(
  equiposOrdenados,
  (nuevaLista) => {
    clasififacionEquipo.value = nuevaLista;
  },
  { immediate: true }
);

// Emparejamientos de todas las rondas anteriores, bye incluido: así no se repite ninguno en todo el torneo
function getPairingsRondasAnteriores(): PairingDTO[] {
  if (!props.partidas || props.ronda <= 1) return [];

  const vistos = new Set<string>();

  return props.partidas
    .filter(
      (p) =>
        p.numeroRonda < props.ronda &&
        typeof p.idEquipo1 === "number" &&
        typeof p.idEquipo2 === "number"
    )
    .filter((p) => {
      const id1 = p.idEquipo1 as number;
      const id2 = p.idEquipo2 as number;
      const key = [id1, id2].sort((a, b) => a - b).join("-");
      if (vistos.has(key)) return false;
      vistos.add(key);
      return true;
    })
    .map((p) => ({
      idEquipo1: p.idEquipo1 as number,
      idEquipo2: p.idEquipo2 as number,
    }));
}

const confirmarConfiguracion = async () => {
  isGenerating.value = true;

  let necesitaBye: boolean;
  if (opcionImpares.value == "SI") necesitaBye = true;
  else necesitaBye = false;

  let repetirRival: boolean;
  if (esRepetirRivalCheck.value == "SI") repetirRival = true;
  else repetirRival = false;

  const pairingsPrevios = getPairingsRondasAnteriores();

  if (
    clasififacionEquipo.value != undefined &&
    props.partidas.length > 0 &&
    props.torneo
  ) {
    const request: GenerarOtraRondaEquiposRequestDTO = {
      clasificacion: clasififacionEquipo.value,
      permiteRepetirRival: repetirRival,
      necesitaBye: necesitaBye,
      pairingRondaAnterior: pairingsPrevios,
      idTorneo: props.torneo.torneo.idTorneo,
      idRonda: props.ronda,
    };

    try {
      await generarOtraRondaTorneoEquipos(request);

      isGenerating.value = false;
      showSuccessModal.value = true;
      confirmGenerate();
    } catch (error) {
      console.error(error);
      showErrorModal.value = true;
      isGenerating.value = false;
    } finally {
      isGenerating.value = false;
      //closeModal();
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: internalIsVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((internalIsVisible).value = $event)),
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Configurar Ronda " + _toDisplayString(props.ronda), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio_group, {
                      modelValue: esRepetirRivalCheck.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((esRepetirRivalCheck).value = $event)),
                      label: "¿Se pueden repetir emparejamientos?"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_radio, {
                          label: "SI",
                          value: "SI"
                        }),
                        _createVNode(_component_v_radio, {
                          label: "NO",
                          value: "NO"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (isImpares.value)
                      ? (_openBlock(), _createBlock(_component_v_radio_group, {
                          key: 0,
                          modelValue: opcionImpares.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((opcionImpares).value = $event)),
                          label: `${esParejas.value ? 'Las parejas' : 'Los equipos'} son impares. ¿Cómo quieres gestionarlo?`
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: "Hacer un bye",
                              value: "SI"
                            }),
                            _createVNode(_component_v_radio, {
                              label: "Nada",
                              value: "NO"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "label"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  justify: "center",
                  class: "ga-5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      disabled: isGenerating.value,
                      onClick: confirmarConfiguracion,
                      color: "primary",
                      variant: "tonal"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Generar ronda")
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_v_btn, {
                      variant: "tonal",
                      color: "secondary",
                      onClick: closeModal,
                      large: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancelar")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: isGenerating.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isGenerating).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Ronda generada correctamente.",
      "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: 
      esRepetirRivalCheck.value === 'NO'
        ? 'No se ha podido generar la ronda sin repetir emparejamientos. Prueba a permitir que se repitan.'
        : 'No se ha podido generar la ronda. Inténtalo de nuevo y si el error persiste contacta con el administrador.'
    ,
      "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible", "message"])
  ], 64))
}
}

})